import React, { useMemo, useState } from 'react';

interface AvatarProps {
  name?: string | null;
  imagePath?: string | null;
  size?: number;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ name, imagePath, size = 40, className }) => {
  const [broken, setBroken] = useState(false);
  const initials = useMemo(() => {
    if (!name) return '??';
    const parts = name.trim().split(/\s+/).slice(0, 2);
    const letters = parts.map(part => part[0]?.toUpperCase() || '').join('');
    return letters || '??';
  }, [name]);

  const resolvedSrc = useMemo(() => {
    if (!imagePath || broken) return '';
    if (/^https?:\/\//i.test(imagePath)) return imagePath;
    const base =
      process.env.REACT_APP_API_URL ||
      (typeof window !== 'undefined' ? `${window.location.origin}/api` : '');
    const normalizedPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
    return `${base}${normalizedPath}`;
  }, [broken, imagePath]);

  if (!resolvedSrc) {
    return (
      <div
        className={`avatar avatar--initials ${className || ''}`}
        style={{ width: size, height: size, fontSize: Math.max(12, size / 2.8) }}
      >
        {initials}
      </div>
    );
  }

  return (
    <div
      className={`avatar ${className || ''}`}
      style={{ width: size, height: size }}
    >
      <img
        src={resolvedSrc}
        alt={name || 'User avatar'}
        onError={() => setBroken(true)}
      />
    </div>
  );
};

export default Avatar;
